export enum EntityLevel {
  SuperAdmin = 'superAdmin',
  Marketplace = 'marketplace',
  Organization = 'organization',
  Merchant = 'merchant',
  Store = 'store',
}
